module.exports = __webpack_public_path__ + "static/media/questionCircle.50d16300.svg";